import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FacilityService } from '../service/facility.service';

@Injectable({
    providedIn: 'root'
})
export class FacilityValidators
{
    constructor(private facilityService: FacilityService) { }

    public validateFacilityNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.facilityService.existsFacilityName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ npiExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
